import type { PlaceListItem } from "../../types";
import { useEdition } from "../../hooks/useEdition";
import { getImageUrl } from "../../lib/image";
import { getLocalizedName } from "../../lib/localization";
import { ImageWithSkeleton } from "../ui/ImageWithSkeleton";

type PlaceCardProps = {
  place: PlaceListItem;
  onClick: () => void;
};

const MapPinIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export function PlaceCard({ place, onClick }: PlaceCardProps) {
  const { locale, edition } = useEdition();
  const fallback = edition?.default_locale_code;
  const placeName =
    getLocalizedName(place, locale, fallback) ?? "";
  const imageUrl = getImageUrl(place.image, "medium");
  const placeTypeName = place.place_type
    ? getLocalizedName(place.place_type, locale, fallback)
    : null;

  return (
    <button
      type="button"
      className="festapp-artist-card"
      data-item-id={place._id}
      onClick={onClick}
    >
      <div className="festapp-artist-card-image">
        <ImageWithSkeleton
          src={imageUrl}
          alt={placeName}
          fallbackIcon={MapPinIcon}
        />
      </div>
      <div className="festapp-artist-card-content">
        <h3 className="festapp-artist-card-name">{placeName}</h3>
        {placeTypeName ? (
          <p className="festapp-artist-card-categories">{placeTypeName}</p>
        ) : (
          <p className="festapp-artist-card-categories">&nbsp;</p>
        )}
      </div>
    </button>
  );
}
